import { AddressErrorCode } from '@cmctechnology/phoenix-stockbroking-api-client';
import { BaseErrorCode } from '../baseErrorCodes';

export const baseAddressErrorCodeMappings: Record<AddressErrorCode, BaseErrorCode> = {
  [AddressErrorCode.InternalError]: BaseErrorCode.UnexpectedError,
  [AddressErrorCode.MissingInput]: BaseErrorCode.UnexpectedError,
  [AddressErrorCode.AddressSearchFail]: BaseErrorCode.UnexpectedError,
  [AddressErrorCode.AddressFormatFail]: BaseErrorCode.UnexpectedError
};
